import * as React from 'react';

import { Root, SeenecoLogoLayout } from './styled';


type LogoProps = {
	appearance?: 'seeneco';
	scale?: number;
}

const Logo: React.SFC<LogoProps> = ({ appearance, scale }) => {
	return (
		<Root>
			{getLogoImage(appearance, scale)}
		</Root>
	);
}

function getLogoImage(name: string, scale: number = 1) {
	const map = {
		'seeneco': () => {
			const width = (36 * scale).toFixed(0);
			const height = (35 * scale).toFixed(0);

			return (
				<SeenecoLogoLayout>
					<svg width={`${width}px`} height={`${height}px`} viewBox='0 0 36 35' version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
						<g transform="translate(92 -171)">
							<use xlinkHref="#path0_fill" transform="translate(-92 171)" fill="#26D06D"/>
						</g>
						<defs>
							<path id="path0_fill" fillRule="evenodd" d="M 33.4415 0.00359215C 21.7902 0.640918 15.5112 6.6951 15.3116 17.4524C 15.2179 22.5 13.2824 25.9831 9.42335 28.1074C 8.10394 28.8337 6.5977 29.3704 4.97256 29.6991C 4.04116 29.8875 3.05052 30.0063 2.42933 30.0063C 1.08765 30.0063 -3.01383e-07 31.1242 -3.01383e-07 32.5032C -3.01383e-07 33.8821 1.08765 35 2.42933 35C 5.36071 35 8.86748 34.0782 11.7173 32.5095C 17.1229 29.5339 20.0418 24.4188 20.1693 17.5476C 20.3199 9.43662 24.5939 5.4883 33.6997 4.99021C 35.0395 4.91692 36.0678 3.74122 35.9965 2.36421C 35.9252 0.987189 34.7813 -0.0696942 33.4415 0.00359215Z"/>
						</defs>
					</svg>
				</SeenecoLogoLayout>
			)}
	}

	return map[name] ? map[name]() : null;
}

Logo.defaultProps = {
	appearance: 'seeneco',
	scale: 1,
};

export default Logo;
